// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.white-button {
    background-color: var(--bg-card);
    color: var(--primary);
    font-size: 14px;
    padding: 8px 20px;
    border-radius: var(--radius-sm);
    font-weight: 600;
    border: 1px solid var(--border);
    transition: all var(--transition-fast);
}

.white-button:hover {
    background-color: var(--primary-light);
    border-color: var(--primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/buttons/button.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;IAChB,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;AAChC","sourcesContent":[".white-button {\n    background-color: var(--bg-card);\n    color: var(--primary);\n    font-size: 14px;\n    padding: 8px 20px;\n    border-radius: var(--radius-sm);\n    font-weight: 600;\n    border: 1px solid var(--border);\n    transition: all var(--transition-fast);\n}\n\n.white-button:hover {\n    background-color: var(--primary-light);\n    border-color: var(--primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
